import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { TransformationSection } from './components/TransformationSection';
import { BonusStack } from './components/BonusStack';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingOptions } from './components/PricingOptions';
import { PackComparison } from './components/PackComparison';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { OpportunityCost } from './components/OpportunityCost';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-clinical-base font-sans text-clinical-ink overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <BonusStack data-id="element-6" />
      <UrgencyBlock data-id="element-7" />
      <PricingOptions data-id="element-8" />
      <PackComparison data-id="element-9" />
      <Testimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <OpportunityCost data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}